import React, { useState } from 'react';
import { Alert, Form, Input, Button, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const G = '#D4AF37';
const GB = '#F4C84A';
const NAVY = '#0A1A3F';
const NAVY2 = '#10254A';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoginError('');
    setLoading(true);
    try {
      await login(values.username, values.password);
      message.success('登录成功！');
      navigate('/dashboard');
    } catch (err) {
      const text = err?.message || '登录失败，请检查账号和密码';
      setLoginError(text);
      message.error(text);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      background: `linear-gradient(180deg, ${NAVY} 0%, ${NAVY2} 100%)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* 背景：等距 3D 夜景城市 */}
      <City3DBackground />

      {/* 顶部细金线 + 标题 */}
      <div style={{
        position: 'absolute', top: 32, left: 0, right: 0, zIndex: 2,
        textAlign: 'center', pointerEvents: 'none',
      }}>
        <div style={{
          display: 'inline-block',
          padding: '6px 18px',
          background: 'rgba(212, 175, 55, 0.08)',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          borderRadius: 20,
          color: G, fontSize: 11, letterSpacing: 4, fontWeight: 500,
          textTransform: 'uppercase',
          boxShadow: `0 0 20px rgba(212, 175, 55, 0.15)`,
        }}>
          BUSINESS MANAGEMENT SYSTEM
        </div>
      </div>

      {/* 登录卡片 */}
      <div style={{
        position: 'relative', zIndex: 3,
        width: 420,
        background: `linear-gradient(135deg, ${NAVY2} 0%, #16315C 100%)`,
        border: '1px solid rgba(212, 175, 55, 0.25)',
        borderRadius: 12,
        boxShadow: `
          0 20px 60px rgba(0, 0, 0, 0.5),
          0 0 0 1px rgba(212, 175, 55, 0.08),
          0 0 60px rgba(212, 175, 55, 0.08) inset
        `,
        padding: '40px 36px 32px',
      }}>
        {/* 顶部金色装饰条 */}
        <div style={{
          position: 'absolute', top: 0, left: 24, right: 24, height: 2,
          background: `linear-gradient(90deg, transparent 0%, ${G} 50%, transparent 100%)`,
          boxShadow: `0 0 12px ${G}`,
        }} />

        {/* Logo + 系统名 */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 12,
            background: `linear-gradient(135deg, ${G} 0%, ${GB} 100%)`,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            color: NAVY, fontSize: 26, fontWeight: 700,
            boxShadow: `0 4px 20px rgba(212, 175, 55, 0.4), 0 0 0 4px rgba(212, 175, 55, 0.1)`,
            marginBottom: 14,
          }}>游</div>
          <div style={{
            color: '#fff', fontSize: 20, fontWeight: 600, letterSpacing: 1,
            marginBottom: 4,
          }}>游暮酒店管理</div>
          <Text style={{ color: G, fontSize: 12, letterSpacing: 2 }}>
            INTELLIGENT · EFFICIENT · SECURE
          </Text>
        </div>

        {/* 登录表单 */}
        <Form onFinish={onFinish} layout="vertical" size="large">
          {loginError && (
            <Alert
              type="error"
              showIcon
              message={loginError}
              style={{ marginBottom: 16 }}
            />
          )}
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
            style={{ marginBottom: 18 }}
          >
            <Input
              prefix={<UserOutlined style={{ color: G }} />}
              placeholder="用户名"
              autoComplete="username"
              style={{
                height: 44, fontSize: 14,
                background: 'rgba(10, 26, 63, 0.5)',
                border: '1px solid rgba(212, 175, 55, 0.25)',
                color: '#E5E7EB',
              }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
            style={{ marginBottom: 24 }}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: G }} />}
              placeholder="密码"
              autoComplete="current-password"
              style={{
                height: 44, fontSize: 14,
                background: 'rgba(10, 26, 63, 0.5)',
                border: '1px solid rgba(212, 175, 55, 0.25)',
                color: '#E5E7EB',
              }}
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            style={{
              height: 46, fontSize: 15, fontWeight: 600, letterSpacing: 4,
              background: `linear-gradient(135deg, ${G} 0%, ${GB} 100%)`,
              border: 'none',
              color: NAVY,
              boxShadow: `0 4px 20px rgba(212, 175, 55, 0.4)`,
            }}
          >
            登 录
          </Button>
        </Form>

        {/* 底部提示 */}
        <div style={{
          marginTop: 24, paddingTop: 20,
          borderTop: '1px solid rgba(212, 175, 55, 0.12)',
          textAlign: 'center',
        }}>
            <Text style={{ color: '#CBD5E1', fontSize: 12, lineHeight: 1.8 }}>
          </Text>
        </div>
      </div>

      {/* 底部：版权 + ICP 备案号 */}
      <div style={{
        position: 'absolute', bottom: 20, left: 0, right: 0, zIndex: 2,
        textAlign: 'center', color: '#6B7280', fontSize: 12, letterSpacing: 0.5,
        lineHeight: 1.9, pointerEvents: 'none',
      }}>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#9CA3AF', textDecoration: 'none', pointerEvents: 'auto' }}
        >
          浙ICP备 2026052534号
        </a>
        <div style={{ color: '#6B7280', fontSize: 11, letterSpacing: 1 }}>
          © 2026 游暮酒店管理 · All Rights Reserved
        </div>
      </div>
    </div>
  );
}

/* ============ 3D 等距夜景城市背景 ============ */
function City3DBackground() {
  return (
    <svg
      style={{
        position: 'absolute', left: 0, right: 0, bottom: 0,
        width: '100%', height: '70%',
        zIndex: 1, pointerEvents: 'none',
      }}
      viewBox="0 0 1200 600"
      preserveAspectRatio="xMidYMax slice"
    >
      <defs>
        {/* 远景建筑渐变 */}
        <linearGradient id="bgSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0A1A3F" stopOpacity="0" />
          <stop offset="50%" stopColor="#10254A" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#16315C" stopOpacity="0.8" />
        </linearGradient>
        {/* 建筑面渐变 - 藏蓝 */}
        <linearGradient id="bldgFront" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1A3263" />
          <stop offset="100%" stopColor="#0A1A3F" />
        </linearGradient>
        <linearGradient id="bldgSide" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0F2244" />
          <stop offset="100%" stopColor="#08152E" />
        </linearGradient>
        <linearGradient id="bldgTop" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2A4275" />
          <stop offset="100%" stopColor="#1A3263" />
        </linearGradient>
        {/* 金色发光 */}
        <radialGradient id="goldGlow">
          <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#D4AF37" stopOpacity="0" />
        </radialGradient>
        {/* 窗户金光 */}
        <linearGradient id="windowGlow" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F4C84A" />
          <stop offset="100%" stopColor="#D4AF37" />
        </linearGradient>
        {/* 地面 */}
        <linearGradient id="ground" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0A1A3F" stopOpacity="0" />
          <stop offset="100%" stopColor="#0A1A3F" />
        </linearGradient>
      </defs>

      {/* 顶部天色填充 */}
      <rect x="0" y="0" width="1200" height="600" fill="url(#bgSky)" />

      {/* 远景山脉剪影 */}
      <path
        d="M0 420 L80 380 L160 410 L240 370 L320 400 L400 360 L480 395 L560 365 L640 400 L720 370 L800 405 L880 375 L960 400 L1040 380 L1120 405 L1200 385 L1200 600 L0 600 Z"
        fill="#0A1A3F" opacity="0.4"
      />

      {/* 中景建筑群 - 等距 3D 风格（侧视图 + 顶面）*/}
      <g>
        {/* 建筑 1 - 左侧高楼 */}
        <g transform="translate(60, 350)">
          <polygon points="0,30 80,0 80,180 0,210" fill="url(#bldgSide)" />
          <polygon points="80,0 100,-10 100,170 80,180" fill="#0A1A3F" />
          <polygon points="0,30 80,0 100,-10 20,20" fill="url(#bldgTop)" />
          {/* 窗户 */}
          {Array.from({ length: 7 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b1-${r}-${c}`}
                x={10 + c * 22}
                y={50 + r * 22}
                width="10" height="12"
                fill={Math.random() > 0.4 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.4 ? 0.9 : 0.3}
              />
            ))
          )}
        </g>

        {/* 建筑 2 - 高塔 */}
        <g transform="translate(180, 280)">
          <polygon points="0,40 70,10 70,250 0,280" fill="url(#bldgFront)" />
          <polygon points="70,10 90,0 90,240 70,250" fill="url(#bldgSide)" />
          <polygon points="0,40 70,10 90,0 20,30" fill="url(#bldgTop)" />
          {/* 顶部天线 */}
          <line x1="80" y1="0" x2="80" y2="-30" stroke={G} strokeWidth="1.5" opacity="0.6" />
          <circle cx="80" cy="-30" r="2" fill={G}>
            <animate attributeName="opacity" values="1;0.3;1" dur="2s" repeatCount="indefinite" />
          </circle>
          {/* 窗户 */}
          {Array.from({ length: 10 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b2-${r}-${c}`}
                x={10 + c * 18}
                y={60 + r * 18}
                width="8" height="10"
                fill={Math.random() > 0.3 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.3 ? 0.95 : 0.25}
              />
            ))
          )}
        </g>

        {/* 建筑 3 - 中等楼 */}
        <g transform="translate(310, 360)">
          <polygon points="0,30 90,-5 90,170 0,200" fill="url(#bldgFront)" />
          <polygon points="90,-5 110,-15 110,160 90,170" fill="url(#bldgSide)" />
          <polygon points="0,30 90,-5 110,-15 20,20" fill="url(#bldgTop)" />
          {Array.from({ length: 6 }).map((_, r) =>
            Array.from({ length: 4 }).map((_, c) => (
              <rect
                key={`b3-${r}-${c}`}
                x={10 + c * 20}
                y={45 + r * 22}
                width="9" height="11"
                fill={Math.random() > 0.4 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.4 ? 0.9 : 0.3}
              />
            ))
          )}
        </g>

        {/* 建筑 4 - 中央主楼（最高）*/}
        <g transform="translate(450, 250)">
          <polygon points="0,50 100,15 100,280 0,310" fill="url(#bldgFront)" />
          <polygon points="100,15 125,5 125,270 100,280" fill="url(#bldgSide)" />
          <polygon points="0,50 100,15 125,5 25,40" fill="url(#bldgTop)" />
          {/* 顶部尖塔 */}
          <polygon points="105,5 113,-10 121,5" fill={G} opacity="0.8" />
          <line x1="113" y1="-10" x2="113" y2="-40" stroke={G} strokeWidth="1.5" opacity="0.6" />
          <circle cx="113" cy="-40" r="2.5" fill={G}>
            <animate attributeName="opacity" values="1;0.4;1" dur="1.5s" repeatCount="indefinite" />
          </circle>
          {/* 顶部金边 */}
          <line x1="0" y1="50" x2="100" y2="15" stroke={G} strokeWidth="1" opacity="0.6" />
          {/* 窗户 */}
          {Array.from({ length: 12 }).map((_, r) =>
            Array.from({ length: 4 }).map((_, c) => (
              <rect
                key={`b4-${r}-${c}`}
                x={10 + c * 22}
                y={65 + r * 20}
                width="10" height="12"
                fill={Math.random() > 0.3 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.3 ? 0.95 : 0.25}
              />
            ))
          )}
        </g>

        {/* 建筑 5 - 右中 */}
        <g transform="translate(630, 320)">
          <polygon points="0,40 80,5 80,220 0,250" fill="url(#bldgFront)" />
          <polygon points="80,5 100,-5 100,210 80,220" fill="url(#bldgSide)" />
          <polygon points="0,40 80,5 100,-5 20,30" fill="url(#bldgTop)" />
          {Array.from({ length: 8 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b5-${r}-${c}`}
                x={10 + c * 22}
                y={55 + r * 22}
                width="10" height="12"
                fill={Math.random() > 0.35 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.35 ? 0.9 : 0.3}
              />
            ))
          )}
        </g>

        {/* 建筑 6 */}
        <g transform="translate(760, 370)">
          <polygon points="0,30 70,0 70,180 0,210" fill="url(#bldgFront)" />
          <polygon points="70,0 88,-10 88,170 70,180" fill="url(#bldgSide)" />
          <polygon points="0,30 70,0 88,-10 18,20" fill="url(#bldgTop)" />
          {Array.from({ length: 7 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b6-${r}-${c}`}
                x={10 + c * 20}
                y={50 + r * 22}
                width="9" height="11"
                fill={Math.random() > 0.4 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.4 ? 0.9 : 0.3}
              />
            ))
          )}
        </g>

        {/* 建筑 7 - 右侧高楼 */}
        <g transform="translate(890, 290)">
          <polygon points="0,50 80,15 80,260 0,290" fill="url(#bldgFront)" />
          <polygon points="80,15 100,5 100,250 80,260" fill="url(#bldgSide)" />
          <polygon points="0,50 80,15 100,5 20,40" fill="url(#bldgTop)" />
          <line x1="90" y1="5" x2="90" y2="-20" stroke={G} strokeWidth="1.5" opacity="0.6" />
          <circle cx="90" cy="-20" r="2" fill={G}>
            <animate attributeName="opacity" values="1;0.3;1" dur="2.2s" repeatCount="indefinite" />
          </circle>
          {Array.from({ length: 10 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b7-${r}-${c}`}
                x={10 + c * 22}
                y={65 + r * 22}
                width="10" height="12"
                fill={Math.random() > 0.3 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.3 ? 0.95 : 0.25}
              />
            ))
          )}
        </g>

        {/* 建筑 8 */}
        <g transform="translate(1020, 350)">
          <polygon points="0,30 70,0 70,180 0,210" fill="url(#bldgFront)" />
          <polygon points="70,0 90,-10 90,170 70,180" fill="url(#bldgSide)" />
          <polygon points="0,30 70,0 90,-10 20,20" fill="url(#bldgTop)" />
          {Array.from({ length: 7 }).map((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`b8-${r}-${c}`}
                x={10 + c * 20}
                y={50 + r * 22}
                width="9" height="11"
                fill={Math.random() > 0.4 ? 'url(#windowGlow)' : '#0A1A3F'}
                opacity={Math.random() > 0.4 ? 0.9 : 0.3}
              />
            ))
          )}
        </g>
      </g>

      {/* 地面 - 网格等距平面 */}
      <g>
        <rect x="0" y="500" width="1200" height="100" fill="url(#ground)" />
        {/* 等距网格线 - 金色 */}
        <g stroke={G} strokeWidth="0.5" opacity="0.4">
          {Array.from({ length: 13 }).map((_, i) => (
            <line key={`v${i}`} x1={i * 100} y1="500" x2={i * 100 + 200} y2="600" />
          ))}
          {Array.from({ length: 7 }).map((_, i) => (
            <line key={`h${i}`} x1="0" y1={500 + i * 15} x2="1200" y2={500 + i * 15} />
          ))}
        </g>
        {/* 地面金色光带 */}
        <line x1="0" y1="500" x2="1200" y2="500" stroke={G} strokeWidth="1" opacity="0.5" />
        <line x1="0" y1="500" x2="1200" y2="500" stroke={G} strokeWidth="2" opacity="0.2" strokeDasharray="4 6" />
      </g>

      {/* 金色光晕装饰 */}
      <circle cx="600" cy="490" r="180" fill="url(#goldGlow)" opacity="0.3" />

      {/* 顶部光轨 */}
      <g opacity="0.4">
        <line x1="0" y1="50" x2="1200" y2="50" stroke={G} strokeWidth="0.5" strokeDasharray="8 12" />
        <line x1="0" y1="80" x2="1200" y2="80" stroke={G} strokeWidth="0.3" strokeDasharray="4 20" />
      </g>

      {/* 流星/光点 */}
      <circle cx="200" cy="120" r="1.5" fill={G}>
        <animate attributeName="opacity" values="0;1;0" dur="3s" repeatCount="indefinite" />
      </circle>
      <circle cx="500" cy="80" r="1" fill="#fff">
        <animate attributeName="opacity" values="0;1;0" dur="4s" repeatCount="indefinite" begin="1s" />
      </circle>
      <circle cx="800" cy="150" r="1.5" fill={G}>
        <animate attributeName="opacity" values="0;1;0" dur="3.5s" repeatCount="indefinite" begin="0.5s" />
      </circle>
      <circle cx="1050" cy="100" r="1" fill="#fff">
        <animate attributeName="opacity" values="0;1;0" dur="4.5s" repeatCount="indefinite" begin="2s" />
      </circle>
    </svg>
  );
}
